import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddExamData from "../../../containers/superadmin/exams/models/add-exam-data";
import SearchBar from "../../../containers/superadmin/exams/searchbar";
import ExamsTable from "../../../containers/superadmin/exams/table";
import {
  getAllExamsRequest,
  getAllExamsSuperAdminRequest,
  getCourseExamRequest,
} from "../../../modules/superadmin-modules/exams/Actions";

const SuperadminExams = () => {
  const dispatch = useDispatch();
  const [courseId, setCourseId] = useState(null);

  const userData = useSelector((state) => state.user.userData);

  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [examData, setExamData] = useState({});

  useEffect(() => {
    if (userData?.role?.length > 0) {
      if (userData?.role?.[0]?.name == "Teacher") {
        dispatch(getAllExamsRequest());
      } else {
        if (courseId) {
          dispatch(getCourseExamRequest(courseId));
        } else {
          dispatch(getAllExamsSuperAdminRequest());
        }
      }
    }
  }, [userData, courseId]);
  return (
    <Layout>
      <SearchBar setAdd={setAdd} setCourseId={setCourseId} />
      <AddExamData
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setExamData={setExamData}
      />
      <ExamsTable setAdd={setAdd} setSelectedData={setSelectedData} />
    </Layout>
  );
};

export default SuperadminExams;
